import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { createAppRouter } from '@app/routing/router';
import { LoadingState } from '@shared/components/SystemStates';

const router = createAppRouter();

export function App() {
  return (
    <Suspense fallback={<LoadingState />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
